export type ThemeMode = 'system' | 'dark' | 'light'

export const THEME_STORAGE_KEY = 'leveleria.theme'

export const isThemeMode = (value: string | null): value is ThemeMode =>
  value === 'system' || value === 'dark' || value === 'light'
